module.exports = __webpack_public_path__ + "img/music.f694a3e6.svg";